module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921011151_T.66f65f9b.jpg";